export function buildgroup(VERSION) {
  return {
    templateUrl: 'assets/js/angular/views/partials/buildgroup.html?id=' + VERSION,
  }
}
